import cloudIcon from "@assets/images/cloud.svg";
import { Box, Button, Dialog, DialogActions } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React, { FC } from "react";

const useStyle = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 480,
        width: "100%",
        borderRadius: 16,
        maxHeight: "unset"
      },
      "& .MuiDialogTitle-root": {
        padding: 24
      },
      "& .MuiDialogContent-root": {
        paddingTop: 5
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        padding: "16px 32px 32px 32px",
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem",
        "& .MuiTypography-root": {
          fontSize: "1.8rem"
        }
      }
    },
    dialogHeader: {
      padding: "4rem 24px 16px 24px",
      textAlign: "center"
    },
    cloudIcon: {
      width: 56,
      height: 56,
      marginBottom: "10px"
    },
    title: {
      fontSize: "22px",
      color: "#333",
      marginBottom: "16px"
    },
    subtitle: {
      fontSize: "18px",
      fontWeight: "normal",
      color: "#333"
    },
    btnAction: {
      color: "white",
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%) !important",
      borderRadius: "4px",
      width: "100%",
      padding: "12px",
      "&:hover": {
        background:
          "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%) !important"
      }
    }
  }),
  { name: "OrderProcessingFailed" }
);
interface OrderProcessingFailedProps {
  onConfirm: () => void;
  onCancel: () => void;
  open?: boolean;
  errorSource?: string;
}
const OrderProcessingFailed: FC<OrderProcessingFailedProps> = ({
  onConfirm,
  onCancel,
  open,
  errorSource
}) => {
  const classes = useStyle();
  return (
    <Dialog open={open} onClose={onCancel} className={classes.root}>
      <Box className={classes.dialogHeader}>
        <img src={cloudIcon} alt="" className={classes.cloudIcon} />
        <MyTypography variant="h6" className={classes.title}>
          ไม่สามารถทำรายการได้
        </MyTypography>
        {errorSource ? (
          <MyTypography variant="body2" className={classes.subtitle}>
            {errorSource}
          </MyTypography>
        ) : (
          <MyTypography variant="body2" className={classes.subtitle}>
            เนื่องจากไม่สามารถติดต่อระบบได้ในขณะนี้
            <br />
            กรุณาลองใหม่อีกครั้ง
          </MyTypography>
        )}
      </Box>
      <DialogActions disableSpacing={true}>
        <Button
          id="confirmButton"
          color="primary"
          variant="contained"
          className={classes.btnAction}
          fullWidth={true}
          onClick={onConfirm}
        >
          <MyTypography variant="body1">
            {errorSource ? "ตกลง" : "ปิดหน้าต่าง"}
          </MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrderProcessingFailed;
